import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { DoorClosed, Lightbulb, Network, Tv, Zap } from 'lucide-react';
import { CallToAction } from '../components/CallToAction';

export const Leistungen = () => {
  const { t } = useTranslation();

  const serviceCards = [
    { id: 'elektroinstallation', key: 'installation', icon: Zap },
    { id: 'beleuchtung', key: 'lighting', icon: Lightbulb },
    { id: 'netzwerktechnik', key: 'network', icon: Network },
    { id: 'unterhaltungselektronik', key: 'entertainment', icon: Tv },
    { id: 'sprechanlagen', key: 'intercom', icon: DoorClosed }
  ];

  return (
    <>
      <section className="page-hero" id="top">
        <div className="container page-hero__inner">
          <div>
            <span className="section__eyebrow">{t('servicesPage.hero.eyebrow')}</span>
            <h1>{t('servicesPage.hero.title')}</h1>
            <p className="page-hero__lead">{t('servicesPage.hero.lead')}</p>
          </div>
          <Link className="btn btn--primary" to="/kontakt">
            {t('servicesPage.hero.cta')}
          </Link>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section__header">
            <h2>{t('servicesPage.intro.title')}</h2>
            <p className="section__lead">{t('servicesPage.intro.lead')}</p>
          </div>
          <div className="grid grid--services">
            {serviceCards.map((card) => (
              <article className="card card--service" id={card.id} key={card.id}>
                <div className="card__header">
                  <div className="card__meta">
                    <span className="card__icon" aria-hidden="true">
                      <card.icon className="h-5 w-5" />
                    </span>
                    <span className="card__eyebrow">
                      {t('servicesPage.cardLabel')}
                    </span>
                  </div>
                  <h3 className="card__title">
                    {t(`servicesPage.cards.${card.key}.title`)}
                  </h3>
                </div>
                <p className="card__lead">
                  {t(`servicesPage.cards.${card.key}.lead`)}
                </p>
                <ul className="card__list">
                  <li>{t(`servicesPage.cards.${card.key}.points.one`)}</li>
                  <li>{t(`servicesPage.cards.${card.key}.points.two`)}</li>
                  <li>{t(`servicesPage.cards.${card.key}.points.three`)}</li>
                </ul>
                <div className="card__actions">
                  <Link className="card__cta" to={`/leistungen/${card.id}`}>
                    {t('home.services.action')} <span aria-hidden="true">→</span>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <CallToAction
        title={t('servicesPage.cta.title')}
        description={t('servicesPage.cta.description')}
        ctaLabel={t('servicesPage.cta.button')}
        ctaTo="/kontakt"
      />
    </>
  );
};
